import { resolveImageUrl, resolveSectionClasses } from "@/storyblok/resolvers";
import { AssetData, WorkAtBlockData } from "@/storyblok/schemas";
import { makeEditable } from "@/storyblok/visual-editor";
import { renderRichText } from "@storyblok/js";
import IconPin2 from "../icons/IconPin2";
import IconNumberOfEmployees from "../icons/IconNumberOfEmployees";
import IconMaleFemale from "../icons/IconMaleFemale";
import IconAge from "../icons/IconAge";
import IconHanger from "../icons/IconHanger";
import IconHomeworking from "../icons/IconHomeworking";
import VideoLightbox from "../media/VideoLightbox";

export default function WorkAt({ data }: { data: WorkAtBlockData }) {
  return (
    <section
      id={data.anchor}
      className="section--work-at"
      {...makeEditable(data)}
      style={{
        "--color-background": data.background_color?.color,
      }}
    >
      <div className={resolveSectionClasses(data, "container")}>
        <div className="container">
          <div className="col">
            <h3 style={{ color: "var(--section--work-at_title-color)" }}>
              {data.title}
            </h3>
            <div
              style={{ color: "var(--section--work-at_text-color)" }}
              dangerouslySetInnerHTML={{ __html: renderRichText(data.content) }}
            ></div>
          </div>
          {data.video_poster?.filename && (
            <div className="col video">
              {data.video && data.video_poster && (
                <VideoLightbox
                  src={data.video.filename}
                  poster={resolveImageUrl(data.video_poster as AssetData, {
                    width: 800,
                  })}
                  alt={data.video_poster.alt}
                />
              )}
            </div>
          )}
        </div>
        <ul>
          {(!!data.location_title || !!data.location_text) && (
            <li>
              <IconPin2 />
              <h4 style={{ color: "var(--section--work-at_usp-title-color)" }}>
                {data.location_title}
              </h4>
              <p style={{ color: "var(--section--work-at_usp-text-color)" }}>
                {data.location_text}
              </p>
            </li>
          )}
          {(!!data.employees_title || !!data.employees_text) && (
            <li>
              <IconNumberOfEmployees />
              <h4 style={{ color: "var(--section--work-at_usp-title-color)" }}>
                {data.employees_title}
              </h4>
              <p style={{ color: "var(--section--work-at_usp-text-color)" }}>
                {data.employees_text}
              </p>
            </li>
          )}
          {(!!data.gender_rate_title || !!data.gender_rate_text) && (
            <li>
              <IconMaleFemale />
              <h4 style={{ color: "var(--section--work-at_usp-title-color)" }}>
                {data.gender_rate_title}
              </h4>
              <p style={{ color: "var(--section--work-at_usp-text-color)" }}>
                {data.gender_rate_text}
              </p>
            </li>
          )}
          {(!!data.age_title || !!data.age_text) && (
            <li>
              <IconAge />
              <h4 style={{ color: "var(--section--work-at_usp-title-color)" }}>
                {data.age_title}
              </h4>
              <p style={{ color: "var(--section--work-at_usp-text-color)" }}>
                {data.age_text}
              </p>
            </li>
          )}
          {(!!data.dresscode_title || !!data.dresscode_text) && (
            <li>
              <IconHanger />
              <h4 style={{ color: "var(--section--work-at_usp-title-color)" }}>
                {data.dresscode_title}
              </h4>
              <p style={{ color: "var(--section--work-at_usp-text-color)" }}>
                {data.dresscode_text}
              </p>
            </li>
          )}
          {(!!data.work_from_title || !!data.work_from_text) && (
            <li>
              <IconHomeworking />
              <h4 style={{ color: "var(--section--work-at_usp-title-color)" }}>
                {data.work_from_title}
              </h4>
              <p style={{ color: "var(--section--work-at_usp-text-color)" }}>
                {data.work_from_text}
              </p>
            </li>
          )}
        </ul>
        {data.button ? (
          <div className="btn_row">
            <a
              className="btn"
              href={`#${data.button.anchor}`}
              {...makeEditable(data.button)}
            >
              {data.button.label}
            </a>
          </div>
        ) : (
          <hr
            style={{
              background: "transparent",
              border: 0,
              margin: 0,
              height: "min(max(30px, 3.5vw), 60px)",
            }}
          />
        )}
      </div>
    </section>
  );
}
